// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BRAND_AMBASSADOR = "AMBAS\u00c1DORKA";
